module.exports = __webpack_public_path__ + "img/FALogo.386c8459.svg";